import React from 'react';
import { resolveContentUnitLabel } from '../../platform/contentUnitLabel';

function ContentUnitTag({ item, unitNames, className = '' }) {
  const label = resolveContentUnitLabel(item, unitNames);
  const classNames = ['platform-content-list-category-tag', className]
    .filter(Boolean)
    .join(' ');

  return <span className={classNames}>{label}</span>;
}

export default ContentUnitTag;
